import { Link } from "react-router-dom";

const NewsCard = ({ image, title, date, link }) => (
  <div className="card rounded shadow-sm">
    <img className="card-img-top" src={image} alt={title} />
    <div className="card-body">
      <h5 className="card-title">{title}</h5>
      <p className="card-text">{date}</p>
    </div>
    <div className="card-footer">
      <Link className="btn btn-primary" to={link}>
        Detalii
      </Link>
    </div>
  </div>
);

export default NewsCard;
